<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("denomination", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $t("denomination_dash_msg") }}
        </div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Denominations')"
          variant="default"
          to="add-denomination"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-end mb-3"></div>

    <div class="white-wrapper mt-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex col-3">
          <multiselect
            :options="Countries"
            v-model="selected_country"
            :searchable="true"
            label="country_name"
            track-by="country_name"
            placeholder="Select Country"
            @select="onSelectCountry($event)"
            :allowEmpty="false"
            :showLabels="false"
          ></multiselect>
        </div>
        <div
          v-if="selectedCountry != 'country'"
          class="d-flex align-items-center"
        >
        <div>
          <b-dropdown :text="isActive == 'Y' ? 'Active' : 'Inactive'" variant="dropdown-curve"
        class="ml-auto mr-3 filter-status-dropdown mb-2">
        <!-- <b-dropdown-item @click="onChangeFilterIsActive('')">All User</b-dropdown-item> -->
        <b-dropdown-item @click="onChangeActive('Y')">Active</b-dropdown-item>
        <b-dropdown-item @click="onChangeActive('N')">Inactive</b-dropdown-item>
      </b-dropdown>
        </div>
          <div class="mx-2">
            <b-dropdown name="listview" id="listview" variant="outline-blue">
              <template v-slot:button-content>
                <!-- Viewing&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp; -->
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <button
            class="btnj btn-gridView mr-3"
            v-if="GridViewFlag"
            :class="gridView ? 'active' : ''"
            v-on:click="viewType('gridView')"
          ></button>
          <button
            class="btnj btn-listView"
            v-if="GridViewFlag"
            :class="listView ? 'active' : ''"
            v-on:click="viewType('listView')"
          ></button>
        </div>
      </div>

      <table class="list-view-table mb-0" v-if="listView">
        <thead>
          <tr>
            <th class="" style="width: 50px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th class="text-center" style="width: 100px">
              <img
                v-if="this.columnName != 'denomination_value'"
                @click="onSortValue('denomination_value', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('denomination_value', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('denomination_value', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("denomination", 1) }} Value
            </th>
            <th class="text-center" style="width: 200px">
              <img
                v-if="this.columnName != 'curr_code'"
                @click="onSortValue('curr_code', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('curr_code', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('curr_code', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("currency", 1) }} Code
            </th>
          </tr>
        </thead>
        <tbody v-if="denominations.length > 0">
          <tr
            v-for="(denomination, denominationIndex) in denominations"
            :key="denominationIndex"
            class="light_grey_back"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    denomination.denomination_is_active === 'Y'
                      ? 'active'
                      : denomination.denomination_is_active === 'N' &&
                        'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-2">
                  <b-dropdown-item
                    v-if="$can('update', 'Denominations')"
                    @click="
                      goToRoute('/master/edit-denomination', denomination)
                    "
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="
                      goToRoute('/master/view-denomination', denomination)
                    "
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->

            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    denomination.denomination_is_active === 'Y'
                      ? 'active'
                      : 'inactive'
                  "
                />

                <div class="ml-2">
                  <i
                    v-if="$can('update', 'Denominations')"
                    @click="
                      goToRoute('/master/edit-denomination', denomination)
                    "
                    class="edit-pen icon blue-icon cursor-pointer"
                    v-b-tooltip="'Edit'"
                    tabindex="0"
                  ></i>
                  <i
                    @click="
                      goToRoute('/master/view-denomination', denomination)
                    "
                    class="icon-eye icon blue-icon cursor-pointer"
                    v-b-tooltip="'View'"
                    tabindex="0"
                  ></i>
                </div>
              </div>
            </td>

            <td class="text-center">
              {{ denomination.denomination_value }}
            </td>
            <td class="text-center">{{ denomination.curr_code }}</td>
          </tr>
        </tbody>
        <tbody v-if="denominations.length == 0">
          <tr>
            <td colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-pagination
      v-if="rows > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!-- GRID VIEW -->
    <div
      class="desg-grid-container"
      v-if="gridView && denominations.length > 0"
    >
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(denomination, denominationIndex) in denominations"
        :key="denominationIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ denomination.denomination_value }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Denominations')"
                  @click="goToRoute('/master/edit-denomination', denomination)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-denomination', denomination)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">{{ denomination.curr_code }}</div>
              <!-- <div class="text">
                No of
                <br />employees
              </div>-->
            </div>
            <div class="d-flex align-items-end">
              <div class="col-4">
                <!-- <b-form-checkbox
                  disabled
                  v-model="denomination.denomination_is_active"
                  unchecked-value="N"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox> -->
                <StatusDot
                  :status="
                    denomination.denomination_is_active === 'Y'
                      ? 'active'
                      : denomination.denomination_is_active === 'N' &&
                        'inactive'
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="denominations.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      selected_country: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",

      selectedCountry: "country",
      Countries: [],
      denominations: [],
      viewingnumbers: [],
      gridView: false,
      listView: true,
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      isActive:"Y"
    };
  },
  beforeMount() {
    this.getCountryList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  mounted() {},
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getDenominationList(this.selectedid);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangeActive(type) {
      this.isActive = type
      this.getDenominationList(this.selectedid);
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getDenominationList(this.selectedid);
      } else {
        this.currentPage = event;
        this.getDenominationList(this.selectedid);
      }
    },
    getCountryList: function () {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Countries = data.Records;
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getDenominationList: function (country_id) {
      // this.denominations = [];
      let payload = {
        tableName: "ms_countries",
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        is_active:this.isActive
      };
      MasterService.GetDenomination(country_id, payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.denominations = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.denominations = [];
            this.rows =0;
            this.selectedvalue=0;
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          this.denominations = [];
          // Catch Error:
          console.log("Catch Error on getDenominationList :", error);
        });
    },
    goToRoute: function (path, { denomination_id }) {
      this.$router.push({
        path: path,
        query: {
          id: denomination_id,
        },
      });
    },
    onSelectCountry: function (event) {
      this.selectedCountry = event.country_name;
      this.selectedid = event.country_id;
      this.getDenominationList(event.country_id);
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/DenominationsComponents/denominations.vue